$(function () {
	$('.delivery-address').each(function () {
		var radios = $(this).find('.radio-with-description__input > input[type="radio"]');
		radios.toggleDisabledFields();
		radios.on('change', function () {
			radios.toggleDisabledFields();
		});
	});
});